/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconSquareRoundedLetterN = createReactComponent("outline", "square-rounded-letter-n", "IconSquareRoundedLetterN", [["path", { "d": "M10 16v-8l4 8v-8", "key": "svg-0" }], ["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-1" }]]);

export { IconSquareRoundedLetterN as default };
//# sourceMappingURL=IconSquareRoundedLetterN.mjs.map
